import { patchState, updateProp } from '../utils';
import { expirationTimeout } from '../../shared/utils';

export const initialState = {
  ticket: undefined,
  expirationToken: undefined,
  isAuthenticated: false,
  profile: null,
  user: null
};

export const authReducers = (state = initialState, action) => {
  switch (action.type) {
    case 'REFRESH_EXPIRATION_TOKEN': {
      return updateProp(state, 'expirationToken', expirationTimeout())
    }

    case 'AUTH_PATCH_STATE' :
    case 'INVALIDATE_USER' : {
      return patchState(state, action);
    }

    default:
      return state;
  }
};
